import styled from 'styled-components';

import BaseWrapper from 'shared/components/presentational/Wrapper/Wrapper';
import CustomLink from 'shared/components/presentational/CustomLink/CustomLink';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

export const Wrapper = styled(BaseWrapper)`
  --title-position: left;
  padding: 0 var(--spacing-m);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
`;

export const SectionTitle = styled.h2`
  margin: var(--spacing-xs) 0;
  font-family: ${FONT_FAMILIES.base};
  font-weight: ${FONT_WEIGHTS.demi};
`;

export const List = styled.ul`
  border: 1px solid var(--surface-border-default);
  border-radius: var(--border-radius-m);
`;

export const ListItem = styled.li`
  &:not(:last-child) {
    border-bottom: 1px solid var(--surface-border-default);
  }
`;

export const Link = styled(CustomLink)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-s) var(--spacing-m);
  font-size: var(--text-size-l);
  line-height: var(--line-height-l);
`;
